/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Model_Settings_Reasoning_Desc_MaxInputs */



/**
* | output |
* | --- |
* | "The deepest reasoning, for when correctness matters more than speed or cost." |
*
* @param {Model_Settings_Reasoning_Desc_MaxInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const model_settings_reasoning_desc_max = /** @type {((inputs?: Model_Settings_Reasoning_Desc_MaxInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Model_Settings_Reasoning_Desc_MaxInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Die gründlichste Begründung, wenn Korrektheit wichtiger ist als Tempo oder Kosten.")
	return /** @type {LocalizedString} */ ("The deepest reasoning, for when correctness matters more than speed or cost.")
});